import { useAPI, useAuth } from '@/modules';
import { User, UserData } from '@/data/types';

const { user } = useAuth();

// eslint-disable-next-line arrow-body-style
export const useAgencyList = () => {
  return { };
};
